const module = { name: 'theater/details/shared/tdp.loadCalendar', exports: {} }; const exports = module.exports;



import { default as calendar } from 'swug-fdRequire-call:theater/details/shared/calendar';



import { default as formatFilters } from 'swug-fdRequire-call:theater/details/shared/formatFilters';



import { default as showtimes } from 'swug-fdRequire-call:theater/details/shared/showtimes';

function onFilterChange(filter) {
    showtimes.applyFilter(filter);
}
function onShowtimesDone(err, results) {
    if (err || !results) {
        return;
    }
    formatFilters.load(results?.formats, onFilterChange);
}
function onCalendarDone(err, results) {
    if (err) {
        return showtimes.notifyUnavailable();
    }
    const filter = formatFilters.getActiveFilter();
    showtimes.load(results.selectedDate, filter, onShowtimesDone);
}
function init() {
    calendar.load(onCalendarDone);
}
module.exports = {
    init
};
export default module.exports;